
import { useEffect, useRef, useState } from 'react';

export default function ClientTrust() {
  const [visibleColumns, setVisibleColumns] = useState<number[]>([]);
  const sectionRef = useRef<HTMLDivElement>(null);

  const clientCategories = [
    {
      id: 1,
      category: 'Private Residences',
      examples: ['Ikoyi', 'Banana Island', 'Lekki Phase 1']
    },
    {
      id: 2,
      category: 'Commercial Spaces',
      examples: ['Boutique Hotels', 'Executive Offices', 'Retail Flagships']
    },
    {
      id: 3,
      category: 'Institutional Projects',
      examples: ['Private Clubs', 'Gallery Spaces', 'Corporate Headquarters']
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = parseInt(entry.target.getAttribute('data-column-id') || '0');
            setTimeout(() => {
              setVisibleColumns((prev) => [...new Set([...prev, id])]);
            }, (id - 1) * 200);
          }
        });
      },
      { threshold: 0.3 }
    );

    const columnElements = sectionRef.current?.querySelectorAll('[data-column-id]');
    columnElements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-[#FAFAF8] min-h-[40vh] md:min-h-[60vh] py-12 md:py-16 lg:py-20 px-4 sm:px-6 md:px-12 lg:px-[100px]">
      <h2 className="text-2xl sm:text-3xl md:text-[42px] font-serif text-[#2C2C2C] mb-10 md:mb-16 lg:mb-[120px] text-center md:text-left">
        Trusted by discerning clients.
      </h2>

      <div className="flex flex-col sm:flex-row justify-center gap-8 md:gap-12 lg:gap-20">
        {clientCategories.map((category) => (
          <div
            key={category.id}
            data-column-id={category.id}
            className={`w-full sm:w-[200px] md:w-[240px] lg:w-[280px] text-center transition-opacity duration-700 ${
              visibleColumns.includes(category.id) ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <p className="text-xs md:text-sm lg:text-base uppercase tracking-[0.1em] text-[#6B6B6B] mb-4 md:mb-6">
              {category.category}
            </p>
            <div className="space-y-3 md:space-y-4 lg:space-y-6">
              {category.examples.map((example, index) => (
                <p key={index} className="text-base md:text-lg font-serif text-[#2C2C2C] leading-6">
                  {example}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
